import type { QueryClient } from "@tanstack/react-query";
import { TransactionCodesApi } from "@/openapi/generated";
import type { GetTransactionCodeResponse } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { sortTransactionCodesBySortOrder } from "@/features/transaction-codes/utils/transaction-code-sort";

export async function prefetchTransactionCodesGet(
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching transaction codes");
  }

  const api = createAuthenticatedApi(TransactionCodesApi, accessToken);

  await queryClient.prefetchQuery<GetTransactionCodeResponse[]>({
    queryKey: [QueryKeys.TransactionCodes],
    queryFn: async () => {
      try {
        const items = await api.apiTransactionCodesGet({});
        return sortTransactionCodesBySortOrder(items);
      } catch {
        return [];
      }
    },
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
